import React, {Component, Fragment} from "react";
import PageHeaderLayout from "../../layout/PageHeaderLayout";
import {Card, Popconfirm, Divider, Drawer} from "antd";
import StandardTable from "../../components/StandardTable";
import authWrapper from "../../utils/authWrapper";
import OrderPurchaseDetail from "./purchaseDetail";
import * as api from "../../api/orderPurchase";
import PurchasePreview from "./purchasePreview";


const PrintFragment = authWrapper('print')(Fragment);
const DeletePopconfirm = authWrapper('delete')(Popconfirm);

class OrderPurchase extends Component {

    columns = [
        {
            title: '订购单',
            dataIndex: 'purchase_no'
        },
        {
            title: '创建日期',
            dataIndex: 'created_time'
        },
        {
            title: '操作',
            render: (record) => (
                <span>
                    <Fragment>
                        <a onClick={() => this.onDetailModalShow(record)}>明细</a>
                        <Divider type={'vertical'} />
                    </Fragment>
                    {/*<PrintFragment>*/}
                    {/*            <a onClick={() => this.onPrint(record)}>打印</a>*/}
                    {/*            <Divider type={'vertical'} />*/}
                    {/*</PrintFragment>*/}
                     <DeletePopconfirm title={'是否确认删除'} onConfirm={() => this.onDelete(record.id)}>
                                <a>删除</a>
                     </DeletePopconfirm>
                </span>
            )
        }
    ]

    state = {
        selectedRecord: null,

        detailModalVisible: false,

        modalPreviewVisible: false,
        modalPreviewRecords: [],
        modalPreviewOrder: {},
        modalPreviewLoading: false
    }

    onDetailModalShow = (record) => {
        this.setState({
            selectedRecord: record,
            detailModalVisible: true
        })
    }

    onPrint = (record) => {
        this.setState({modalPreviewLoading: true})
        api.detailPurchase(record.id).then(({data}) => {
            this.setState({
                modalPreviewVisible: true,
                modalPreviewLoading: false,
                modalPreviewRecords: data.data,
                modalPreviewOrder: record
            })
        }).catch(() => {
            this.setState({modalPreviewLoading: false})
        })
    }

    onDelete = (purchaseId) => {
        api.deletePurchase(purchaseId).then(() => {
            this.dataTable.fetch()
        })
    }

    render() {
        return (
            <PageHeaderLayout title={'订购单'}>
                <Card>
                    <StandardTable url={'/api/order/purchase/'}
                                   columns={this.columns}
                                   ref={table => this.dataTable = table}
                    />
                </Card>
                <Drawer visible={this.state.detailModalVisible}
                        onClose={() => this.setState({detailModalVisible: false})}
                        width={1100}
                >
                    <OrderPurchaseDetail record={this.state.selectedRecord} />
                </Drawer>
                <PurchasePreview visible={this.state.modalPreviewVisible}
                                 width={1300}
                                 order={this.state.modalPreviewOrder}
                                 records={this.state.modalPreviewRecords}
                                 onCancel={() => this.setState({modalPreviewVisible: false})}
                />
            </PageHeaderLayout>
        );
    }
}

export default OrderPurchase;
